// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-blog-js": () => import("./../../../src/pages/blog.js" /* webpackChunkName: "component---src-pages-blog-js" */),
  "component---src-pages-books-js": () => import("./../../../src/pages/books.js" /* webpackChunkName: "component---src-pages-books-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-blog-blog-content-js": () => import("./../../../src/templates/blog/blog_content.js" /* webpackChunkName: "component---src-templates-blog-blog-content-js" */),
  "component---src-templates-book-book-content-js": () => import("./../../../src/templates/book/book_content.js" /* webpackChunkName: "component---src-templates-book-book-content-js" */)
}

